<!-- =========================================================================================
  File Name: game.vue
  Description: Record Game
========================================================================================== -->

<template>
  <div id="record-game">

    <vx-card title="游戏注单">
      <div slot="actions">
        <vx-input-group>
          <template slot="prepend">
            <flat-pickr v-model="startTime" :config="flatPickrConfig" class="flatpickr-input w-32"></flat-pickr>
          </template>
          <template slot="prepend">
            <flat-pickr v-model="endTime" :config="flatPickrConfig" class="flatpickr-input w-32"></flat-pickr>
          </template>
          <template slot="prepend">
            <vs-select class="w-32" v-model="platType">
              <vs-select-item :key="index" :value="index" :text="item" v-for="(item, index) in platList" />
            </vs-select>
          </template>
          <template slot="prepend">
            <vs-select class="w-32" v-model="gameType">
              <vs-select-item :key="index" :value="index" :text="item" v-for="(item, index) in gameList" />
            </vs-select>
          </template>
          <vs-input class="w-32" v-model="uid" placeholder="UID" />
          <template slot="append">
            <vs-input class="w-32" v-model="username" placeholder="用户名" />
          </template>
          <template slot="append">
            <vs-select class="w-24" v-model="rangeVal">
              <vs-select-item :key="index" :value="item.val" :text="item.name" v-for="(item, index) in range" />
            </vs-select>
          </template>
          <template slot="append">
            <div class="append-text bg-warning cursor-pointer" @click="search">
              <feather-icon icon="SearchIcon"></feather-icon>
            </div>
          </template>
        </vx-input-group>
      </div>
      <vs-table stripe :data="list" noDataText="暂无游戏注单">
        <template slot="thead">
          <vs-th width="120">用户名</vs-th>
          <vs-th>平台类别</vs-th>
          <vs-th>游戏类别</vs-th>
          <vs-th>游戏名称</vs-th>
          <vs-th>投注内容</vs-th>
          <vs-th>总金额 (元)</vs-th>
          <vs-th>盈亏 (元)</vs-th>
          <vs-th>状态</vs-th>
          <vs-th>时间</vs-th>
          <vs-th>操作</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :key="index" v-for="(item, index) in list" class="text-sm">
            <vs-td :data="item.username">{{item.username}}</vs-td>
            <vs-td :data="item.plaType">{{item.platType.toUpperCase()}}</vs-td>
            <vs-td :data="item.gameType">{{gameList[item.gameType]}}</vs-td>
            <vs-td :data="item.gameName">{{item.gameName}}</vs-td>
            <vs-td :data="item.betContent">
              <vs-button color="primary" type="filled" size="small" @click="showContent" :data-index="index">查看详情</vs-button>
            </vs-td>
            <vs-td :data="item.validAmount">{{item.validAmount}}</vs-td>
            <vs-td :data="item.winLoss">{{item.winLoss}}</vs-td>
            <vs-td :data="item.status" :class="{ 'text-success': item.status == 1, 'text-danger': item.status == 2, 'font-bold': item.status == 1 || item.status == 2 }">{{item.statusName}}</vs-td>
            <vs-td :data="item.betDate">{{item.betDate}}</vs-td>
            <vs-td>
              <vs-button color="danger" type="filled" size="small" @click="del" :data-index="index">删除</vs-button>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>

      <vs-pagination class="mt-6" :total="totalPage" v-model="page" goto />
    </vx-card>

  </div>
</template>

<script>

import { Mandarin as flatPickrZh } from 'flatpickr/dist/l10n/zh.js'

export default {
  data() {
    return {
      page: 1,
      totalPage: 1,
      list: [],
      gameList: [],
      platList: [],
      startTime: '',
      endTime: '',
      shortname: '',
      uid: '',
      username: '',
      range: [{ val: '', name: '范围' }, { val: 'self', name: '自身' }, { val: 'team', name: '团队' }],
      rangeVal: '',
      platType: 0,
      gameType: 0,
      flatPickrConfig: {
        enableTime: false,
        dateFormat: 'Y-m-d',
        locale: flatPickrZh
      }
    }
  },
  watch: {
    page(newValue) {
      this.page = newValue
      this.load()
    }
  },
  methods: {
    showContent(e) {
      const index = e.currentTarget.dataset.index
      this.$vs.dialog({
        title: '下注详情',
        text: this.list[index].betContent,
        acceptText: '确认'
      })
    },
    load () {
      const postdata = {}
      postdata.authKey = localStorage.getItem('authKey')
      postdata.page = this.page
      postdata.shortname = this.shortname
      postdata.number = this.number
      postdata.start = this.startTime
      postdata.end = this.endTime
      postdata.uid = this.uid
      postdata.username = this.username
      postdata.range = this.rangeVal
      postdata.platType = this.platType === 0 ? '' : this.platList[this.platType]
      postdata.gameType = this.gameType
      this.$utils.post('record-game', postdata).then(res => {
        this.list = res.list
        this.totalPage = Math.ceil(res.count / res.pagesize)
      })
    },
    del(e) {
      const index = e.currentTarget.dataset.index
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: '确认',
        text: '确认删除该注单吗?',
        acceptText: '确认',
        cancelText: '取消',
        accept: () => {
          const postdata = {}
          postdata.authKey = localStorage.getItem('authKey')
          postdata.id = this.list[index].id
          this.$utils.post('game-orderDelete', postdata).then(res => {
            this.$vs.dialog({
              title: '提示',
              text: res,
              acceptText: '确认'
            })
            this.load()
          })
        }
      })
    },
    search() {
      this.page = 1
      this.load()
    }
  },
  mounted () {
    // 初始化时间
    const myDate = new Date()
    this.endTime = this.$utils.addZero(myDate.getFullYear(), 2) + '-' + this.$utils.addZero((parseInt(myDate.getMonth()) + 1), 2) + '-' + this.$utils.addZero(myDate.getDate(), 2)
    myDate.setTime(myDate.getTime() - 86400000 * 30)
    this.startTime = this.$utils.addZero(myDate.getFullYear(), 2) + '-' + this.$utils.addZero((parseInt(myDate.getMonth()) + 1), 2) + '-' + this.$utils.addZero(myDate.getDate(), 2)

    // 获取所有平台和游戏
    this.$utils.post('game-typeList', { authKey: localStorage.getItem('authKey') }).then(data => {
      this.gameList = ['全部游戏']
      for(let i in data) {
        if (!data[i]) continue
        this.gameList.push(data[i].name)
        for(let k in data[i].list) {
          if (this.platList.indexOf(data[i].list[k]) == -1) {
            this.platList.push(data[i].list[k])
          }
          this.platList.sort()
          this.platList.unshift('全部平台')
        }
      }
    })

    this.load()
  }
}
</script>

<style>
  .vs-dialog-text {
    max-height: 500px;
    overflow-y: auto;
    word-break: break-all;
  }
</style>
